import { BodyConverter } from '@iotize/tap/client/api';

import { TapStreamReader, TapStreamWriter } from '../../frame/import-adapter';

export abstract class EnumConverter<T> implements BodyConverter<T> {
  constructor(public mapping: T) {}

  decode(value: Uint8Array): T {
    const literalValue = this.decodeToLiteral(value);
    const enumStringValue: T | undefined = (this.mapping as any)[literalValue];
    if (!enumStringValue) {
      throw new Error(`Unknown litteral value ${literalValue}.`);
    }
    return literalValue as any as T;
  }

  encode(value: T): Uint8Array {
    if (typeof value !== 'number') {
      throw Error(
        `Illegal argument when encoding enum value. Expecting  number but found ${typeof value}`,
      );
    }
    return this.encodeToLiteral(value as number);
  }

  abstract decodeToLiteral(value: Uint8Array): number;

  abstract encodeToLiteral(value: number): Uint8Array;
}

export class FixedSizeEnumConverter<T> extends EnumConverter<T> {
  constructor(
    public mapping: T,
    public size = 1,
  ) {
    super(mapping);
  }

  decodeToLiteral(value: Uint8Array): number {
    return TapStreamReader.fromArray(value).readU(this.size);
  }
  encodeToLiteral(value: number): Uint8Array {
    return new TapStreamWriter(this.size).writeU(value, this.size).toBytes;
  }
}

export class EnumListConverter<T> implements BodyConverter<T[]> {
  constructor(
    public size: number,
    public mapping: T,
  ) {}

  decode(value: Uint8Array): T[] {
    const bits = this.decodeToLiteral(TapStreamReader.create(value));
    const results = [];
    const enumValues = Object.keys(this.mapping).filter(
      (key) => !isNaN(Number((this.mapping as any)[key])),
    );
    // console.log("numval", enumValues)
    for (const enumName of enumValues) {
      const enumValue = (this.mapping as any)[enumName];
      const mask = parseInt(enumValue);
      if (mask == 0) {
        if (bits == 0) {
          results.push(enumValue);
        }
      } else if ((bits & mask) == mask) {
        results.push(enumValue);
      }
    }
    return results;
  }

  encode(values: T[]): Uint8Array {
    let mask = 0;
    for (const value of values) {
      if (typeof value !== 'number') {
        throw Error(
          `Illegal argument when encoding enum value. Expecting number but found ${typeof value}`,
        );
      }
      mask |= value as number;
    }
    const result = new TapStreamWriter(this.size).writeU(
      mask,
      this.size,
    ).toBytes;
    return result;
  }

  private decodeToLiteral(stream: TapStreamReader): number {
    return stream.readU(this.size);
  }
}
